<tec-modal [isVisible]="isVisible"
	[title]="'CONNECTIONS.IRPF.FORM.VALID_TO' | translate"
	(closeEvent)="closeModal()">
	<ng-container body>
		<span class="text-align-center" [innerHTML]="'CONNECTIONS.IRPF.FORM.VALID_TO_DESCRIPTION' | translate"></span>
        <div style="align-self: center; width: 280px">
            <pwcs-inline-svg src="assets/images/nif-expedition-help.svg" idSuffix="modal-nif-expedition-help" />
        </div>
	</ng-container>
</tec-modal>